import { Typography } from "@mui/material";
import "./index.css";

const YFSLabelItem = ({ name, value, unit }) => {
  return (
    <div className="yfs-label-items">
      <div className="yfs-label-name-item">
        <Typography
          sx={{ fontWeight: "bold", color: "#203669", fontSize: "14px" }}
        >
          {name}
        </Typography>
      </div>
      <div style={{ padding: "0 10px", display: "flex", alignItems: "center" }}>
        <Typography
          sx={{ fontWeight: "light", color: "#203669", fontSize: "14px" }}
        >
          {value} {unit}
        </Typography>
      </div>
    </div>
  );
};
export default YFSLabelItem;
